import { get } from 'lodash';
import { setExtensionRecording } from '../Pages/NewFloContainer/NewFlo.reducers';
import store from '../store';
import {
	setExtensionErrored,
	setInstalledExtension,
} from '../store/reducers/OnBoarding.reducer';
import { isMicroApp } from '../Common/Common.utils';
import { getExtensionVersion } from 'Pages/NewFloContainer/NewFloExtension.actions';

let extensionId =
	process.env.REACT_APP_EXTENSION_ID || 'lhkecgbbmmggmgglgbdpdmjlnmdoahbc';

const urlParams = new URLSearchParams(window.location.search);
const urlExtId = urlParams.get('extId');
if (urlExtId) {
    extensionId = urlExtId; // Override with the URL parameter value
}

let isExtensionInstalled = false;
// @ts-ignore
let port: any;

export const SendMessageToExtension = (action: {
	type: string;
	payload?: unknown;
	token?: string;
}) => {
	try {
		// @ts-ignore
		if (chrome?.runtime?.sendMessage) {
			// @ts-ignore
			chrome.runtime.sendMessage(
				extensionId,
				{
					...action,
					payload: {
						// @ts-ignore
						...(action.payload || {}),
						from: 'app',
					},
				},
				undefined,
				// @ts-ignore
				(...args) => {
					const onBoardingState = get(store?.getState(), 'onBoarding');
					if (args.length === 0) {
						if (get(onBoardingState, 'extensionErrored')) {
							store.dispatch(setExtensionErrored(false));
						}
						if (get(onBoardingState, 'extensionInstalled')) {
							store.dispatch(setInstalledExtension(false));
							store.dispatch(setExtensionRecording(false));
						}
					} else {
						if (get(onBoardingState, 'extensionErrored')) {
							store.dispatch(setExtensionErrored(false));
						}
						if (!get(onBoardingState, 'extensionInstalled')) {
							store.dispatch(setInstalledExtension(true));
						}
					}
				}
			);
			isExtensionInstalled = true;
			const onBoardingState = get(store?.getState(), 'onBoarding');
			if (get(onBoardingState, 'extensionErrored')) {
				store.dispatch(setExtensionErrored(false));
			}
		}
	} catch (e) {
		store.dispatch(setExtensionErrored(true));
		store.dispatch(setInstalledExtension(false));
		isExtensionInstalled = false;

		checkConnection();
	}
};

let interval: NodeJS.Timer;

function checkConnection() {
	if (interval) return;
	interval = setInterval(async () => {
		clearInterval(interval);
		if (isExtensionInstalled) {
			clearInterval(interval);
		} else if (!port) {
			try {
				// @ts-ignore
				port = await chrome.runtime.connect(extensionId);
				isExtensionInstalled = true;
				store.dispatch(setInstalledExtension(true));
				SendMessageToExtension(getExtensionVersion({}));
				await new Promise((resolve) => setTimeout(resolve, 100));
				port.onDisconnect.addListener(() => {
					isExtensionInstalled = false;
					// store.dispatch(setInstalledExtension(false));
					checkExtensionUninstalled();
				});
			} catch (e) {
				store.dispatch(setInstalledExtension(false));
				isExtensionInstalled = false;
			}
		} else if (port) {
			try {
				port.postMessage({ type: 'test' });
				SendMessageToExtension(getExtensionVersion({}));
			} catch (e) {
				port.disconnect();
				port = null;
				store.dispatch(setInstalledExtension(false));
				store.dispatch(setExtensionErrored(false));
				store.dispatch(setExtensionRecording(false));
				isExtensionInstalled = false;
			}
		}
	}, 5000);
}

checkConnection();

export const checkExtensionUninstalled = () => {
	port?.disconnect();
	port = null;
	isExtensionInstalled = false;
	SendMessageToExtension({
		type: 'test',
	});
	checkConnection();
};

export const disconnectExtension = () => {
	port?.disconnect();
};

const origins = {
	'dev-floik': ['https://us.realmofdev.com', 'http://localhost:3000'],
	floik: ['https://app.floik.com'],
	'dev-doc360': [
		'https://test-micro-app.realmofdev.com',
		'https://portal.texas.document360.net',
		'https://portal.dev.document360.net',
		'https://portal.qatar.document360.net',
		'https://portal.florida.document360.net',
		'https://portal.qa.document360.net',
		'https://portal.mumbai.document360.net',
		'https://portal.delhi.document360.net',
		'https://portal.berlin.document360.net',
		'http://localhost:4200',
		'https://portal.document360.net',
		'https://portal.document360.info',
		'https://portal.sharjah.document360.net/',
	],
	doc360: [
		'https://portal.document360.io',
		'https://portal.us.document360.io',
		'https://portal.ca.document360.io',
		'https://portal.wk.document360.io',
		'https://portal.neurocrine.document360.io',
		'https://portal.airtable.document360.io',
		'https://portal.craneww.document360.io',
		'https://portal.internal.document360.io',
	],
};

export const ExtensionListener = (
	cb: (action: { type: string; payload?: unknown }) => void
) => {
	const onMessage = (event: Event) => {
		const appKey = isMicroApp() ? 'doc360' : 'floik';
		const envKey =  (process.env.REACT_APP_ENVIRONMENT || '') === 'production' ? '' : 'dev-';
		const key = 	`${envKey}${appKey}`;
		const matchingOrigin = get(origins, key, []).includes(get(event, 'origin'));
		if (!matchingOrigin) return;
		// @ts-ignore
		cb(get(event, 'data') as { type: string; payload?: unknown });
	};
	window.addEventListener('message', onMessage, false);
	return () => {
		window.removeEventListener('message', onMessage, false);
	};
};
